import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../LanguageContext';
import './About.css';
import './PageShell.css';

export default function About() {
  const { language } = useLanguage();
  const text = language === 'zh' ? {
    title: '关于 Oblitrok',
    subtitle: '连接专业人才，让技能协作更简单',
    cards: [
      ['🎯', '我们的使命', '连接技能人才与项目需求方，通过高效协作让每个人都能找到发挥才能的舞台。'],
      ['🌍', '开放生态', '汇聚多领域服务者，构建多主体协同创作生态。'],
      ['💡', '创新驱动', '以产品化流程组织人才、需求、交付和支付，让协作更清晰。'],
      ['🤝', '公平公正', '沉淀认证、评价和交易记录，保障服务者与客户的长期信任。'],
    ],
    stats: ['注册自由职业者', '成功完成项目', '累计交易额', '客户满意度'],
    ctaTitle: '准备好加入我们了吗？',
    ctaText: '无论你是需要人才的客户，还是想展示才能的专业人士，都欢迎加入Oblitrok。',
    register: '立即注册',
    browse: '浏览需求',
  } : {
    title: 'About Oblitrok',
    subtitle: 'Connect with professional talent and make skill collaboration simpler.',
    cards: [
      ['🎯', 'Our mission', 'Connect skilled professionals with project owners through efficient collaboration.'],
      ['🌍', 'Open ecosystem', 'Bring multi-disciplinary providers together into a collaborative service marketplace.'],
      ['💡', 'Product-led delivery', 'Organize talent, requirements, delivery, and payments into a clearer workflow.'],
      ['🤝', 'Trust and fairness', 'Build long-term trust through verification, reviews, and transaction records.'],
    ],
    stats: ['Registered freelancers', 'Completed projects', 'Transaction volume', 'Client satisfaction'],
    ctaTitle: 'Ready to join us?',
    ctaText: 'Whether you need talent or want to offer your skills, Oblitrok gives you a focused place to collaborate.',
    register: 'Sign up',
    browse: 'Browse requirements',
  };
  return (
    <div className="ab-page page-shell-page">
      <div className="ab-hero">
        <div className="container">
          <h1>{text.title}</h1>
          <p>{text.subtitle}</p>
        </div>
      </div>

      <section className="container ab-section">
        <div className="ab-grid">
          {text.cards.map(([icon, title, body]) => (
            <div className="ab-card" key={title}>
              <div className="ab-icon">{icon}</div>
              <h3>{title}</h3>
              <p>{body}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="ab-stats-section">
        <div className="container">
          <div className="ab-stats">
            <div>
              <div className="ab-big">12,000+</div>
              <div className="ab-lbl">{text.stats[0]}</div>
            </div>
            <div>
              <div className="ab-big">45,000+</div>
              <div className="ab-lbl">{text.stats[1]}</div>
            </div>
            <div>
              <div className="ab-big">¥2.8亿</div>
              <div className="ab-lbl">{text.stats[2]}</div>
            </div>
            <div>
              <div className="ab-big">98%</div>
              <div className="ab-lbl">{text.stats[3]}</div>
            </div>
          </div>
        </div>
      </section>

      <section className="container ab-section">
        <div className="ab-cta">
          <h2>{text.ctaTitle}</h2>
          <p>{text.ctaText}</p>
          <div className="ab-cta-btns">
            <Link to="/register" className="btn btn-primary">{text.register}</Link>
            <Link to="/tasks" className="btn btn-ghost">{text.browse}</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
